import React, { useState } from "react";
import Table from "@mui/material/Table";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import api from "../../../../api/medAppApi";
import LinearProgress from "@mui/material/LinearProgress";
import Toolbar from "@mui/material/Toolbar";
import Badge from '@mui/material/Badge';
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import { alpha } from "@mui/material/styles";
import DeleteDialog from "../../../../components/DeleteDialog";
import pluralize from "pluralize";
// components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Admin } from "../../../../models";
import { putMessage } from "../../../app/store/actions";
import AdminListWidget from "./admin-list.component";
import AppLink from "../../../../components/AppLink";
import { ROUTES } from "../../../../history";

function AdminsPage() {
  // const [isLoading, setIsLoading] = useState(true);
  const [admins, setAdmins] = useState<Admin[]>([]);
  const [total, setTotal] = useState(0);
  const [rows, setRows] = useState(0);
  const [selectedList, setSelectedList] = useState<number[]>([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [open2, setOpen2] = useState(false);

  const [page, setPage] = useState(1);

  const dispatch = useDispatch();
  function isContained(id: number): boolean {
    return selectedList.includes(id);
  }

  const loadMore = async () => {
    let ans;
    let current = page;
    let n = {
      Role: {
        "!=": "super_admin",
      },
    };
    ans = await api.getModelList<Admin>({
      modelName: "admin",
      returnType: "list",
      crieteria: n,
      limit: 20,
      page: current,
    });
    return ans.data;
  };
  const { data, isFetching, refetch, isError } = useQuery(
    "load-admins",
    loadMore,
    { refetchOnWindowFocus: false }
  );

  React.useEffect(() => {
    if (!data) return;
    let ans = data!.data!;
    if (ans) {
      setAdmins(ans.payload);
      setTotal(ans.total);
      setRows(ans.rows);
    }
  }, [data]);

  React.useEffect(() => {
    // setIsLoading(isFetching);
    setLoading(isFetching);
  }, [isFetching]);

  function checkAdmin(admin: Admin) {
    if (!isContained(admin.id)) {
      setSelectedList(selectedList.concat([admin.id]));
    } else {
      let index = selectedList.indexOf(admin.id);
      let list = selectedList
        .slice(0, index)
        .concat(selectedList.slice(index + 1, selectedList.length));
      setSelectedList(list);
    }
  }

  React.useEffect(() => {
    if (isFetching) return;
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  React.useEffect(
    () => {
      if (isError) {
        dispatch(putMessage({ type: "error", message: "Failed to load data" }));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isError]
  );

  function onDialogClose(
    event: {},
    reason: "backdropClick" | "escapeKeyDown" | "buttonClick",
    ans: number
  ) {
    if (loading) return;
    setOpen(false);
    if (ans === 2) {
      let items = selectedList.map((v) => ({ id: v }));
      deleteModels(items);
    }
    console.log(event, reason, ans);
  }

  const deleteModels = async (ids: Array<{ id: number }>) => {
    setLoading(true);
    let ans = await api.deleteModels({ modelName: "invite", ids });
    console.log(ans);
    setSelectedList([]);
    refetch();
  };
  const loader = <LinearProgress />;
  const body = (
    <TableBody>
      {admins.map((item, index) => (
        <AdminListWidget
          key={"admin-" + index}
          admin={item}
          onClickCheck={checkAdmin}
          active={isContained(item.id)}
          tableRow
        />
      ))}
    </TableBody>
  );
  return (
    <Box padding="1em">
      <DeleteDialog
        open={open}
        title="Delete Lab Tests"
        body={`Are you sure you want to delete ***${pluralize(
          "Lab Test",
          selectedList.length,
          true
        )}***, They will be  **deleted** and removed removed forever`}
        loading={loading}
        onClose={onDialogClose}
      />
      <Toolbar
        sx={{
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(selectedList.length > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity
              ),
          }),
        }}
      >
        {selectedList.length > 0 ? (
          <Typography
            sx={{ flex: "1 1 100%" }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {selectedList.length} selected
          </Typography>
        ) : (
          <Box display="flex" alignItems="center">
            <Box display="flex" sx={{ flex: "1 1 100%" }} alignItems={"center"}>
              <IconButton
                disabled={page === 1}
                onClick={() => {
                  setPage(page - 1);
                }}
              >
                <ChevronLeftIcon />
              </IconButton>
              <Typography id="tableTitle" fontSize={"12px"}>
                {(page - 1) * 20 + 1} to {page * 20 > total ? total : page * 20}{" "}
                of {total}
              </Typography>
              <IconButton
                disabled={page === rows}
                onClick={() => {
                  setPage(page + 1);
                }}
              >
                <ChevronRightIcon />
              </IconButton>
            </Box>

            <Box px={10}>
              <AppLink to={ROUTES.ADMIN_BASE + '/admin-orgs/view-all'} doNotUseButton>
              <Badge color="primary" badgeContent={(<span>Organizations</span>)} />

              </AppLink>
            </Box>
          </Box>
        )}
        {!!selectedList.length && (
          <Tooltip title="Delete">
            <IconButton
              onClick={() => {
                setOpen(true);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </Toolbar>
      {isFetching && loader}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="right">Email</TableCell>
              <TableCell align="right">Role</TableCell>
              <TableCell align="right">Organizattion</TableCell>
            </TableRow>
          </TableHead>

          {body}
        </Table>
      </TableContainer>
    </Box>
  );
}

export default AdminsPage;
